import { ClipboardCheckIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { DropdownMenuItem } from '../../../components/ui/dropdown-menu.tsx';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import type { CustomerDTO } from '../../../server/dto/customer-dto.ts';
import { Can } from '../../acl/can.tsx';
import { DialogStateManager } from '../../dialog/dialog-provider.tsx';
import type { LogInteractionFormProps } from './log-interaction-dialog.tsx';
import { LogInteractionDialog } from './log-interaction-dialog.tsx';

export type DropdownMenuItemCreateNoteProps = {
    customer?: CustomerDTO;
    onSuccess?: () => void;
    analyticsSource?: LogInteractionFormProps['analyticsSource'];
};

export const DropdownMenuItemCreateNote = ({
    customer,
    onSuccess,
    analyticsSource,
}: DropdownMenuItemCreateNoteProps): ReactNode => {
    const { t } = useLocale();

    return (
        <Can I="create" a="Note">
            <DropdownMenuItem
                onSelect={() => {
                    void DialogStateManager.show(LogInteractionDialog, {
                        customer,
                        onSuccess,
                        analyticsSource,
                    } satisfies LogInteractionFormProps);
                }}
            >
                <ClipboardCheckIcon className="h-4 w-4" />
                <span>{t('top_navbar__new_note')}</span>
            </DropdownMenuItem>
        </Can>
    );
};
